const registeredModals = {
	options: () => import('./options'),
	confirm: () => import('./confirm'),
	message: () => import('./message'),
	agreement: () => import('./agreement'),
	auth: () => import('./auth'),
	otpPin: () => import('./otp-pin'),
	notifications: () => import('./notifications'),
	paymentCardSelection: () => import('./payment-card-selection'),
	tableNumberConfirmation: () => import('./table-number-confirmation'),
};

export default registeredModals;
